import React from "react";
import { SFInfoIcon, SFHelpSupportIcon } from "../../icons";
import getStyled from "../../../hooks/getStyled";
import SFTooltip from "../../tooltip";

const { styled } = getStyled();

// Use span to make the icon in the tooltip hoverable
const ClickableTooltipWrapper = styled("span")(({ theme }) => ({
  display: "flex", // To remove the extra space around the icon
  cursor: "pointer",
}));

const TooltipButton = ({
  tooltip,
  position = "bottom-start",
  width,
  iconColor = "grey400",
  variant = "info",
  onClick = () => {},
}) => {
  const Icon = variant === "info" ? SFInfoIcon : SFHelpSupportIcon;
  return (
    <>
      <SFTooltip placement={position} width={width} content={tooltip}>
        <ClickableTooltipWrapper onClick={onClick}>
          <Icon size="small" color={iconColor} />
        </ClickableTooltipWrapper>
      </SFTooltip>
    </>
  );
};

export default TooltipButton;
